<template>
  <v-navigation-drawer
    id="videoChatContent"
    transition="slide-x-transition"
    v-model="$store.state.videoChat.showConversation"
    v-show="$store.state.videoChat.showConversation"
    :app="this.$vuetify.breakpoint.xs ? true : false"
    :left="this.$vuetify.breakpoint.xs ? false : true"
    :absolute="this.$vuetify.breakpoint.xs ? false : true"
    :width="this.$vuetify.breakpoint.sm ? '400' : '500'"
    height="100%"
    style="z-index: 100"
    elevation="0"
    :overlay-opacity="0.15"
  >
    <template v-slot:prepend>
      <v-btn
        style="z-index: 1"
        class="mt-2"
        icon
        absolute
        right
        dark
        color="black"
        @click="$store.state.videoChat.showConversation = false"
      >
        <v-icon size="30">mdi-close</v-icon>
      </v-btn>
      <v-list>
        <v-list-item class="mx-2">
          <v-list-item-avatar>
            <v-icon size="35">mdi-forum</v-icon>
          </v-list-item-avatar>
          <v-list-item-subtitle> Conversation </v-list-item-subtitle>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
    </template>
    <template v-slot:append>
      <v-textarea
        class="mt-1"
        outlined
        flat
        rows="2"
        hide-details
        clearable
        placeholder="Write your message here"
        v-model.trim="chat_input"
        @keydown.enter.exact.prevent
        @keyup.enter.exact="send()"
      >
      </v-textarea>
    </template>

    <v-list
      v-for="(item, i) in VideoMessages"
      :key="i"
      class="py-0"
      ref="videoChatContent"
    >
      <v-list-item :class="item.sender_type == 'admin' ? 'admin' : ''">
        <v-list-item-avatar v-if="item.sender_type != 'admin'">
          <v-icon size="35" color="cleed_blue">mdi-account-circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-avatar color="white" v-else>
          <v-img src="/safari-pinned-tab.svg" height="34" contain />
        </v-list-item-avatar>
        <div class="msg-bubble">
          <div class="msg-info">
            <div class="msg-info-name">
              <span v-if="item.sender_type != 'admin'">
                {{
                  $store.state.chat_user.firstname ||
                  $store.state.chat_user.email ||
                  `#${$store.state.chat_user.id}`
                }}
              </span>
              <span v-else> Store admin </span>
            </div>
            <div class="msg-info-time">
              {{ item.time }}
            </div>
          </div>

          <div class="msg-text">
            {{ item.content }}
          </div>
        </div>
      </v-list-item>
      <v-divider></v-divider>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "videoConversation",
  data() {
    return {
      chat_input: "",
    };
  },
  computed: {
    videoSocket() {
      return this.$store.state.videoChat.socketAddr;
    },
    VideoMessages() {
      return this.$store.state.videoChat.messages;
    },
  },
  created() {
    console.log("showConversation");
  },
  mounted() {
    const content = document
      .getElementById("videoChatContent")
      .getElementsByClassName("v-navigation-drawer__content")[0];
    this.$store.state.videoChat.RefVideoChatContent = content;
    content.scrollTop = content.scrollHeight;
  },
  updated() {
    const content = document
      .getElementById("videoChatContent")
      .getElementsByClassName("v-navigation-drawer__content")[0];
    this.$store.state.videoChat.RefVideoChatContent = content;
    content.scrollTop = content.scrollHeight;
  },
  methods: {
    send() {
      if (!this.chat_input) {
        this.$store.dispatch("setSnackbar", {
          text: `text is empty`,
          color: "error",
          bottom: true,
          timeout: 1000,
        });
        return;
      }
      const dateWithouthSecond = new Date();
      const time = dateWithouthSecond.toLocaleTimeString(navigator.language, {
        hour: "2-digit",
        minute: "2-digit",
      });
      const data = {
        guid: this.$store.state.chat_user.guid,
        content: this.chat_input,
        sender_type: "admin",
        mode: "chat",
        time: time,
        video_chat: true,
      };
      this.$socket.emit("VIDEO_CHAT_ADMIN_sendMessage", data, (cb) => {
        if (typeof cb === "string") {
          console.error(cb);
        } else if (cb.success == false) {
          this.$store.dispatch("setSnackbar", {
            text: `Error during sending the message : ${cb.error}`,
            color: "error",
            bottom: true,
            timeout: 3000,
          });
        } else {
          this.VideoMessages.push(data);
          this.chat_input = "";
        }
      });
    },
  },
};
</script>
<style scoped>
.msg-bubble {
  width: 100%;
  padding: 15px;
  border-radius: 15px;
  background: var(--left-msg-bg);
}
.msg-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.msg-info-name {
  margin-right: 10px;
  font-weight: bold;
}
.msg-info-time {
  font-size: 0.85em;
}
.admin {
  background: #e4e3e37a;
}
.v-application--is-ltr
  .v-textarea.v-text-field--enclosed
  .v-text-field__slot
  textarea {
  resize: none;
}
</style>
